import { NgModule } from '@angular/core';
import { MjJobListingComponent } from './mj-job-listing.component';
import { MjJobListingItemComponent } from './mj-job-listing-item/mj-job-listing-item.component';
import { MjListingFabComponent } from './mj-listing-fab/mj-listing-fab.component';
import { MjListingAddItemContainerComponent } from './mj-listing-add-item-container/mj-listing-add-item-container.component';
import { MjListingItemCameraButtonComponent } from './mj-listing-item-camera-button/mj-listing-item-camera-button.component';
import { MjListingItemPaintButtonComponent } from './mj-listing-item-paint-button/mj-listing-item-paint-button.component';
import { MjListingItemTextPaintButtonComponent } from './mj-listing-item-text-paint-button/mj-listing-item-text-paint-button.component';
import { MjListingItemRemoveButtonComponent } from './mj-listing-item-remove-button/mj-listing-item-remove-button.component';
import { MjListingItemToolsComponent } from './mj-listing-item-tools/mj-listing-item-tools.component';
import { MjListingSortableContainerComponent } from './mj-listing-sortable-container/mj-listing-sortable-container.component';
import { CommonModule } from '@angular/common';
import { JobHeaderComponent } from './job-header/job-header.component';
import { JobFooterComponent } from './job-footer/job-footer.component';
import { JobUnitDescriptionComponent } from './job-unit-description/job-unit-description.component';
import { JobVideoComponent } from './job-video/job-video.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { JobFreeTextComponent } from './job-free-text/job-free-text.component';
import { JobFreeTextImageComponent } from './job-free-text-image/job-free-text-image.component';
import { JobImageComponent } from './job-image/job-image.component';
import { JobJobsComponent } from './job-jobs/job-jobs.component';
import { SharedModule } from '../shared-module/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AboutJobInfoComponent } from './about-job-info/about-job-info.component';
import { JobDescriptionComponent } from './job-description/job-description.component';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';

@NgModule({
  declarations: [
    MjJobListingComponent,
    MjJobListingItemComponent,
    MjListingAddItemContainerComponent,
    MjListingFabComponent,
    MjListingItemCameraButtonComponent,
    MjListingItemPaintButtonComponent,
    MjListingItemTextPaintButtonComponent,
    MjListingItemRemoveButtonComponent,
    MjListingItemToolsComponent,
    MjListingSortableContainerComponent,
    JobHeaderComponent,
    JobFooterComponent,
    JobUnitDescriptionComponent,
    JobVideoComponent,
    JobFreeTextComponent,
    JobFreeTextImageComponent,
    JobImageComponent,
    JobJobsComponent,
    AboutJobInfoComponent,
    JobDescriptionComponent,
  ],
  exports: [
    MjJobListingComponent,
    MjJobListingItemComponent,
    MjListingAddItemContainerComponent,
    MjListingFabComponent,
    MjListingItemCameraButtonComponent,
    MjListingItemPaintButtonComponent,
    MjListingItemTextPaintButtonComponent,
    MjListingItemRemoveButtonComponent,
    MjListingItemToolsComponent,
    MjListingSortableContainerComponent,
    JobHeaderComponent,
    JobFooterComponent,
    JobUnitDescriptionComponent,
    JobVideoComponent,
    JobFreeTextComponent,
    JobFreeTextImageComponent,
    JobImageComponent,
    JobJobsComponent,
    AboutJobInfoComponent,
    JobDescriptionComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MatMenuModule,
    TranslateModule,
    DragDropModule,
    MatFormFieldModule,
    MatButtonModule,
    LeafletModule,
    MatInputModule,
    MatCheckboxModule,
  ],
})
export class JobListingModule {}
